import IconRoot, { Props } from './Icon'

export default function Icon(props: Props) {
  return <IconRoot {...props} />
}

export type { Props } from './Icon'
